import { combineReducers } from "redux";
import { ActionType } from "typesafe-actions";

import { tipsterPreferencesActions } from "./actions";
import {
  TIPSTER_PREFERENCES_FAILURE,
  TIPSTER_PREFERENCES_REQUEST,
  TIPSTER_PREFERENCES_SUCCESS,
} from "../../constants/tipsterPreferences";
import { Sport } from "../sports/reducer";
import { Bookie } from "../bookies/reducer";
import { ConfidenceType } from "../../components/Shops/Tip/components/TipBox/Bottom/Confidence";
import { Stake } from "../../components/TipPublish/interfaces/utils";
export interface TipsterPreferences {
  tipster_id: string;
  bookie_ids: string;
  sport_codes: string[];
  market_codes: string[];
  stakes: Stake[];
  market_codes_by_sport: any;
}
export type TipsterConfidences = {
  created_at: string;
  range_from: number;
  range_to: number;
  tipster_id: string;
  type: ConfidenceType;
  updated_at: string;
};
export type TipsterPreferencesState = {
  requested: boolean;
  data: {
    tipster_preferences: TipsterPreferences;
    is_super_confidence_available: boolean;
    until_super_confidence_available: {
      days: number;
      hours: number;
      minutes: number;
    };
    sports: Sport[];
    bookies: Bookie[];
    next_super_confidence_tip_available_at: string | null;
    tipster_confidences: TipsterConfidences[];
  };
  isLoading: boolean;
  error: string | null;
};
export type TipsterPreferencesActions = ActionType<
  typeof tipsterPreferencesActions
>;

export const tipsterPreferencesReducer = combineReducers<
  TipsterPreferencesState,
  TipsterPreferencesActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case TIPSTER_PREFERENCES_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (
    state = {
      tipster_preferences: {
        tipster_id: "",
        bookie_ids: "",
        sport_codes: [],
        market_codes: [],
        stakes: [],
        market_codes_by_sport: [],
      },
      sports: [],
      bookies: [],
      tipster_confidences: [],
      next_super_confidence_tip_available_at: null,
      is_super_confidence_available: true,
      until_super_confidence_available: {
        days: -1,
        hours: -1,
        minutes: -1,
      },
    },
    action
  ) => {
    switch (action.type) {
      case TIPSTER_PREFERENCES_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = true, action) => {
    switch (action.type) {
      case TIPSTER_PREFERENCES_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case TIPSTER_PREFERENCES_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
